module.exports = __webpack_public_path__ + "static/media/3.18ea50a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3.jpg
// module id = 873
// module chunks = 0